'use client';

import { useCallback, useRef, useState } from 'react';

/**
 * Guard for SEO redirect round-trips: blocks updateURL flashes and keeps
 * SeoListingChrome on the previous H1 until resolve settles.
 */
export const useListingSeoPending = () => {
  const isSeoPendingRef = useRef(false);
  const [isSeoPending, setIsSeoPending] = useState(false);

  const beginSeoNavigation = useCallback((): void => {
    isSeoPendingRef.current = true;
    setIsSeoPending(true);
  }, []);

  const endSeoNavigation = useCallback((): void => {
    isSeoPendingRef.current = false;
    setIsSeoPending(false);
  }, []);

  return {
    isSeoPending,
    isSeoPendingRef,
    beginSeoNavigation,
    endSeoNavigation,
  };
};
